import React from "react";

function Flag({ country, size }) {
  const currentSize = size === "small" ? 18 : size === "medium" ? 48 : size === "large" ? 64 : 32;
  return (
    <img
      alt={`${country.toLowerCase()}_flag`}
      width={currentSize}
      src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.toUpperCase()}.svg`}
    />
  );
}

export default Flag;
